import { AutogenModelRatewareTariffCode, AutogenRowRatewareTariffCode } from "./autogen/AutogenModelRatewareTariffCode";

export class ModelRatewareTariffCode extends AutogenModelRatewareTariffCode<RowRatewareTariffCode> {
	constructor() {
		super(RowRatewareTariffCode);
	}
}

export class RowRatewareTariffCode extends AutogenRowRatewareTariffCode {
}